<!-- eslint-disable vue/no-v-html -->
<template>
    <span
        class="nuxt-icon block"
        :class="iconSizeClass"
        aria-hidden="true"
        v-html="icon"
    />
</template>

<script setup lang="ts">
import { ref, reactive, watchEffect, onUnmounted } from '#imports'

const props = withDefaults(defineProps<{
    name: string;
    size?: string;
}>(), {size: 'md'})

const iconSizeClass = reactive({
    'w-3 h-3': props.size === 'xs',
    'w-4 h-4': props.size === 'sm',
    'w-5 h-5': props.size === 'md',
    'w-6 h-6': props.size === 'lg',
    'w-8 h-8': props.size === 'xl',
    'w-10 h-10': props.size === '2xl',
    'w-12 h-12': props.size === '3xl',
    '': props.size === 'none',
})

const icon = ref<string>('')

async function loadIcon() {
    if (!props.name) {
        icon.value = ''
        return
    }

    try {
        const iconModule = await import(`~/assets/icons/${props.name}.svg?raw`)
        icon.value = iconModule.default || ''
    } catch (e) {
        console.error(`[nuxt-icons] Icon '${props.name}' doesn't exist in 'assets/icons'`)
        icon.value = ''
    }
}

// Watch for prop changes with proper cleanup
const stopWatcher = watchEffect(() => {
    loadIcon()
})

// Cleanup for SSR safety and memory leak prevention
onUnmounted(() => {
    stopWatcher()
    icon.value = ''
})
</script>
